import { render, staticRenderFns } from "./comp_Hook-ProductPage-InfoAccordions.vue?vue&type=template&id=4bb9c95c&scoped=true"
import script from "./comp_Hook-ProductPage-InfoAccordions.vue?vue&type=script&lang=js"
export * from "./comp_Hook-ProductPage-InfoAccordions.vue?vue&type=script&lang=js"
import style0 from "./comp_Hook-ProductPage-InfoAccordions.vue?vue&type=style&index=0&id=4bb9c95c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb9c95c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VIcon})
